export { default as Roaming } from './Roaming/Roaming';
export { default as DiscountedRoamingCalls } from './DiscountedRoamingCalls/DiscountedRoamingCalls';
export { default as RoamingMain } from './Roaming/RoamingMain';
export { default as BeforeTrip } from './Before-trip/Before-trip';
export { default as BannerAzer } from './BannerAzer/BannerAzer';
export { default as GeneralServices } from './GeneralServices/GeneralServices';
export { default as Questions } from './Questions/Questions';
export { default as Steps } from './Steps/Steps';
export { default as PricesAndCountries } from './PricesAndCountries/PricesAndCountries';
export { default as SpecialOffers } from './SpecialOffers/SpecialOffers';
export { default as RoamingActivation } from './RoamingActivation/RoamingActivation';
export { default as Advantageous } from './Advantageous/Advantageous';
export { default as InternetActivation } from './InternetActivation/InternetActivation';
